module.exports = __webpack_public_path__ + "files/3ff0d48ea352c7dc42bc809fa939776e.png";